import { useQuery } from '@tanstack/react-query';

import { apiGetContactRelatedContactOptions } from 'api/acturis/client-center';

import type {
  ActurisInterestedPartyOption,
  ActurisRelatedContactOption,
} from 'api/acturis/client-center';

export const CLIENT_CENTER_RELATED_CONTACT_OPTIONS_KEY =
  'client-center-related-contact-options';

const EMPTY_RELATIONSHIP_TYPES: ActurisRelatedContactOption[] = [];
const EMPTY_INTERESTED_PARTY_TYPES: ActurisInterestedPartyOption[] = [];

export const useClientCenterRelatedContactOptions = (
  customerId: string,
  enabled: boolean,
) => {
  const { data, isLoading, error } = useQuery({
    queryKey: [CLIENT_CENTER_RELATED_CONTACT_OPTIONS_KEY, customerId],
    queryFn: () => apiGetContactRelatedContactOptions(customerId),
    enabled: Boolean(customerId) && enabled,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  return {
    relationshipTypes: data?.relationship_types ?? EMPTY_RELATIONSHIP_TYPES,
    interestedPartyTypes:
      data?.interested_party_types ?? EMPTY_INTERESTED_PARTY_TYPES,
    isLoading,
    error,
  };
};
